import _defineProperty from "@babel/runtime/helpers/defineProperty";
var TYPES = {
  PRE_PRODUCTION: 'PRE_PRODUCTION',
  PRODUCTION: 'PRODUCTION'
};
var STATUS = _defineProperty(_defineProperty({}, TYPES.PRE_PRODUCTION, {
  DEMO: 'DEMO',
  DEV: 'DEV',
  QA: 'QA',
  STG: 'STG'
}), TYPES.PRODUCTION, {
  PROD: 'PROD'
});
export default {
  STATUS: STATUS,
  TYPES: TYPES,
  URL_STRING_TO_SEARCH: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, STATUS.PRE_PRODUCTION.DEMO, '.demo.'), STATUS.PRE_PRODUCTION.DEV, '.dev.'), STATUS.PRE_PRODUCTION.QA, '.qa.'), STATUS.PRE_PRODUCTION.STG, '.stg.')
};